import { render, staticRenderFns } from "./RecycleBinModal.vue?vue&type=template&id=2be4b670&"
import script from "./RecycleBinModal.vue?vue&type=script&lang=js&"
export * from "./RecycleBinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports